import { Component } from "react";
import { NavLink } from 'react-router-dom';

class BackToHomePage extends Component{

    render(){
        return(
            <div 
            className="mx-12 md:mx-32 text-white w-20 h-20">       
                <NavLink to="/" exact className="w-20 h-20">
                    <button className="fa fa-chevron-circle-left text-3xl md:text-6xl text-white">
                        
                    </button>
                </NavLink> 
            </div>
        )
    }
}

export default BackToHomePage;